import axios from 'axios';
import { getValidToken } from './authService';


const API_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getValidToken(); 
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const getGroups = async () => {
  const response = await apiClient.get('/groups');
  return response.data;
};

export const createGroup = async (groupData) => {
  const response = await apiClient.post('/groups', groupData);
  return response.data;
};

export const getGroupDetails = async (groupId) => {
  const response = await apiClient.get(`/groups/${groupId}`);
  return response.data;
};

export const updateGroup = async (groupId, groupData) => {
  const response = await apiClient.put(`/groups/${groupId}`, groupData);
  return response.data;
};

export const deleteGroup = async (groupId) => {
  const response = await apiClient.delete(`/groups/${groupId}`);
  return response.data;
};

export const getGroupMembers = async (groupId) => {
  const response = await apiClient.get(`/groups/${groupId}/members`);
  return response.data;
};

export const leaveGroup = async (groupId, userId) => {
  const response = await apiClient.delete(`/groups/${groupId}/members/${userId}`);
  return response.data;
};

export const removeGroupMember = async (groupId, userId) => {
  const response = await apiClient.delete(`/groups/${groupId}/members/${userId}`);
  return response.data;
};